import React, { useContext } from 'react';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { HTTP_CODE } from '../utils/redirector-utils';

const handler = ({ props }) => {

  const notFound = {
    shouldRedirect: false,
    isErrorStatus: true,
    httpCode: HTTP_CODE.NOT_FOUND,
    description: 'Generic 4xx',
  };
  return new RedirectTag(notFound, props.bypass);
};

export const Generic4xx = () => {
  const data = {};
  const error = {};
  const { bypass } = useContext(RedirectContext);
  const props = {
    bypass,
  };

  useHelmet('4xxRedirect', { data, error, props }, handler, []);
  return null;
};

Generic4xx.displayName = 'Generic4xx';
